<template>
  <form class="form-signin" v-on:submit.prevent>
    <h2 class="form-signin-heading">Вход в административный раздел</h2>
    <div class="login-wrap">
      <input type="text" v-model="email" class="form-control" placeholder="email" autofocus>
      <input type="password" v-model="password" class="form-control" placeholder="Password">
      <b-alert variant="danger" dismissible :show="showErrorAlert" @dismissed="showErrorAlert=false"> {{ error_text }} </b-alert>
      <label class="checkbox">
        <span class="pull-right">
          <a data-toggle="modal" href="#myModal"> восстановление пароля</a>
        </span>
      </label>
      <button class="btn btn-lg btn-login btn-block" v-on:click="loginauth">Вход</button>
    </div>
  </form>
</template>

<script>
import { AUTH_REQUEST } from '../../store/actions';

export default {
  data: () => ({
    email: '',
    password: '',
    error_text: '',
    showErrorAlert: false,
  }),
  methods: {
    loginauth(event) {
      this.showErrorAlert = false;
      const { email, password } = this;
      this.$store.dispatch(AUTH_REQUEST, { email, password })
        .then(() => {
          const orig = `${window.location.protocol}//${window.location.host}`;
          const referrer = document.referrer;
          const reg = new RegExp(`${orig}(?!login\/).*`);

          if (referrer.match(reg) !== null) {
            window.location.href = referrer;
          } else {
            window.location.href = '/status-photos';
          }
        })
        .catch((e) => {
          if (typeof e.data.success === 'undefined' && e.data.success === false) {
            this.error_text = 'Неправильный email или пароль. Или все вместе.';
            this.showErrorAlert = true;
          } else {
            this.error_text = 'Произошла ошибка во время авторизации.';
            this.showErrorAlert = true;
          }
        });
    },
  },
};
</script>

<style>
.form-signin {
    max-width: 330px;
    margin: 100px auto 0;
    background: #fff;
    border-radius: 5px;
    -webkit-border-radius: 5px;
}

.form-signin h2.form-signin-heading {
  margin: 0;
  padding: 20px 15px;
  text-align: center;
  background: #41cac0;
  border-radius: 5px 5px 0 0;
  -webkit-border-radius: 5px 5px 0 0;
  color: #fff;
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 300;
  font-family: Open Sans, sans-serif;
}
body {
    color: #797979;
    font-family: Open Sans,sans-serif;
    font-size: 13px;
}
.login-wrap {
    padding: 20px;
}
.form-signin .btn-login {
    background: #f67a6e;
    color: #fff;
    text-transform: uppercase;
    font-weight: 300;
    font-family: Open Sans,sans-serif;
    box-shadow: 0 4px #e56b60;
    margin-bottom: 20px;
}
.form-signin input[type="password"], .form-signin input[type="text"] {
    margin-bottom: 15px;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    border: 1px solid #eaeaea;
    box-shadow: none;
    font-size: 12px;
}
.form-signin .form-control {
    position: relative;
    font-size: 16px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.form-control {
    color: #777;
    width: 100%;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/login/LoginComponent.vue